import { all, takeEvery, put, call } from 'redux-saga/effects'
import { getTiposSvg, insertTipoSvg } from 'services/personalizacion'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_TIPOS_SVG() {
  try {
    const tiposSvgData = yield call(getTiposSvg)
    if (tiposSvgData.ok) {
      yield put({
        type: actions.TIPOS_SVG_LOAD_SUCCEEDED,
        payload: tiposSvgData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Tipos SVG')
      put({
        type: actions.TIPOS_SVG_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.TIPOS_SVG_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_TIPO_SVG(action) {
  try {
    const tipoObj = yield call(insertTipoSvg, action.payload)
    if (tipoObj.ok) {
      putMessage(messageType.SUCCESS, 'Tipo creado correctamente')
      yield put({
        type: actions.TIPOS_SVG_INSERT_SUCCEEDED,
        payload: tipoObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Tipo')
      yield put({
        type: actions.TIPOS_SVG_INSERT_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Tipo')
    yield all([
      put({
        type: actions.TIPOS_SVG_INSERT_FAILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.TIPOS_SVG_LOAD_REQUESTED, GET_TIPOS_SVG),
    takeEvery(actions.TIPOS_SVG_INSERT_REQUESTED, INSERT_TIPO_SVG),
  ])
}
